<script setup lang="ts">
import { inject, provide, ref, watch, type Ref } from "vue";

const props = defineProps<{ index: number; item?: Record<string, any> }>();
const item: Ref<Record<string, any> | undefined> = ref(props.item);
const index: Ref<number> = ref(props.index);
const pIndex = inject<Ref<number>>("index")!;

watch(
  () => props.item,
  (value) => (item.value = value)
);

watch(
  () => props.index,
  (value) => (index.value = value)
);

provide("item", item);
provide("index", index);
provide("pIndex", pIndex);
</script>
<template>
  <slot />
</template>
